import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UsaBannerComponent } from './scaffolding/usa-banner/usa-banner.component';
import { NavBarComponent } from './scaffolding/nav-bar/nav-bar.component';
import { FooterComponent } from './scaffolding/footer/footer.component';
import { ToastContainerComponent } from './core/toast/toast-container.component';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, UsaBannerComponent, NavBarComponent, FooterComponent, ToastContainerComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	protected readonly title = signal('oasis');

	/** Current calendar year for the footer */
	currentYear = new Date().getFullYear();
}
